import type { AppProps, NextWebVitalsMetric } from 'next/app'
import { useReportWebVitals } from 'next/web-vitals'

import { feMetrics } from '@lib/tracking/metrics/femetrics'
import { GeneralClientMetrics, WebVitals } from '@lib/tracking/metrics/metrics'

import { IS_DEVELOPMENT } from '@constants/globals'

import ErrorBoundary from '@components/error-boundary'

import '../styles/app.css'

const getPageSlug = (): string => {
  return window.location.pathname === '/'
    ? window.location.pathname
    : window.location.pathname.slice(1)
}

const reportableMetrics = new Set<string>([
  WebVitals.Hydration,
  WebVitals.TTFB,
  WebVitals.FCP,
  WebVitals.LCP,
  WebVitals.FID,
  WebVitals.CLS,
  WebVitals.INP,
])

export function reportWebVitals(metric: NextWebVitalsMetric) {
  if (IS_DEVELOPMENT) {
    console.log(metric)
  }

  const metricName: string = metric.name === 'Next.js-hydration' ? WebVitals.Hydration : metric.name
  const metricValue: number = Number.parseFloat(metric.value.toFixed(2))

  if (reportableMetrics.has(metricName)) {
    feMetrics
      .getMetric(GeneralClientMetrics.WebVitals)
      .getTimer(metricName)
      .setContext({
        pageSlug: getPageSlug(),
      })
      .recordTime(metricValue)
  }
}

export default function App({ Component, pageProps }: AppProps) {
  useReportWebVitals(reportWebVitals)

  return (
    <ErrorBoundary>
      <Component {...pageProps} />
    </ErrorBoundary>
  )
}
